import { render, staticRenderFns } from "./SLOMonitoring.vue?vue&type=template&id=0a634456&scoped=true"
import script from "./SLOMonitoring.vue?vue&type=script&lang=js"
export * from "./SLOMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a634456",
  null
  
)

export default component.exports